import React, { useState, useEffect, useContext } from 'react'
import './modalReservation.css'
import { Dialog, DialogContent } from '@mui/material'
import FirstPage from './firstPage'
import SecondPage from './secondPage'
import { useMediaQuery } from '@mui/material'
import { BufferService } from '../utils/buffer.service'
import { isValidPhoneNumber } from 'libphonenumber-js'
import LoadingContext from '../utils/loading.context'

export default function ModalReservation({ openModal, setOpenModal, userSelectDic, setUserSelectDic, curtMins, setCurrentWeek, backendCall }) {
    const media1250w = useMediaQuery('(max-width: 1250px)')
    const [firstPage, setFirstPage] = useState(true)
    const backendGet = new BufferService('identity/userrole')
    const [mbway, setMbway] = useState(false)
    const [crediCard, setCrediCard] = useState(false)
    const ctx = useContext(LoadingContext)

    const inputsModal = [
        { label: "Nome", type: "text", code: "Name" },
        {
            label: "Tipo de jogo", type: "radio", code: "TypeGame", options: [
                { label: "Singulares", value: "Single" },
                { label: "Pares", value: "Pares" }
            ]
        },
        { label: "Apelido", type: "text", code: "Surname" },
        { label: "Jogador2", type: "text", code: "Player2" },
        { label: "Email", type: "email", code: "Email" },
        { label: "Jogador3", type: "text", code: "Player3" },
        { label: "Telemóvel", type: "tel", code: "Phone" },
        { label: "Jogador4", type: "text", code: "Player4" },
        {
            label: "Sócio", type: "radio", code: "Partner", options: [
                { label: "Não", value: "nao" },
                { label: "Sim", value: "sim" }
            ]
        },
    ]

    //utils to check number
    const [phoneNumberValid, setPhoneNumberValid] = useState(false)
    const handlePhoneNumberChange = (value) => {
        setPhoneNumberValid(isValidPhoneNumber(value))
    }

    const labelToastMessage = () => {
        return (
            <div>
                <li> Não sócios só podem reservar, no máximo, com 24 horas de antecedência. </li>
                <br />
                <li> Non-members can only make reservations up to 24 hours in advance. </li>
            </div>
        )
    }
    useEffect(() => {
        ctx.setIsLoad(true)
        backendGet.get().then(resPost => {
            if (resPost.name === 'AxiosError') {
                ctx.setIsLoad(false)
                ctx.toastMessages('error', '', "Algo correu mal, tente novamente!")
                setTimeout(function () {
                    window.location.reload()
                }, 2000)
                return
            }

            if(resPost.User.Partner === false && !canReserve(new Map(userSelectDic).get("Datetime"), new Map(userSelectDic).get("ReservationTime"))){
                ctx.toastMessages('error', '', labelToastMessage, 6000)
                ctx.setIsLoad(false)
                setOpenModal(false)
                return
            }else{
                let tempValues = {
                    'Name': resPost.User.FirstName,
                    'Surname': resPost.User.LastName,
                    'Partner': (resPost.User.Partner === true) ? "sim" : "nao",
                    'Nif': resPost.User.VatNumber,
                    'Phone': resPost.User.PhoneNumber,
                    'Email': resPost.User.Email,
                    'Duration': resPost.User.Partner === false || curtMins[0]?.length === 1 ? curtMins[0] : []
                }

                Object.keys(tempValues).forEach(key => {
                    userSelectDic.set(key, tempValues[key])
                })
                if (userSelectDic.get("Phone") !== undefined) {
                    setPhoneNumberValid(isValidPhoneNumber(userSelectDic.get("Phone")))
                }
            }
            
            ctx.setIsLoad(false)
        })
        // eslint-disable-next-line
    }, [])

    const submitReservation = (event, index) => {
        if (index === "Phone" || (event && event.target)) {
            const value = index === "Phone" ? event : event.target.value
            userSelectDic.set(index, value)
            setUserSelectDic(new Map(userSelectDic))
        }
    }

    const handleCloseMessageBoard = () => {
        setOpenModal(false)
        setFirstPage(false)
        setCrediCard(false)
        setMbway(false)
    }

    const handleRadioChange = (e, code) => {
        const selectedValue = e.target.value
        userSelectDic.set(code, selectedValue)
        setUserSelectDic(new Map(userSelectDic))
    }

    const canReserve = (desiredDateTimeStr, desiredTimeStr) => {
        try {
            const datePart = desiredDateTimeStr.split('T')[0];
            const [year, month, day] = datePart.split('-').map(Number);
            const [hours, minutes] = desiredTimeStr.split(':').map(Number);
    
            const desiredDateTime = new Date(year, month - 1, day, hours, minutes);
            const now = new Date();
            const maximumLeadTimeHours = 24; // Alterado para máximo
    
            const timeDifferenceMs = desiredDateTime.getTime() - now.getTime();
            const leadTimeHours = timeDifferenceMs / (1000 * 60 * 60);
    
            // Verifica se a antecedência é NO MÁXIMO 24 horas
            return leadTimeHours <= maximumLeadTimeHours && leadTimeHours >= 0;
        } catch (error) {
            console.error("Error parsing date or time:", error);
            return false;
        }
    };

    const maxWidthw = media1250w ? "auto" : "1155px"
    const maxWidthh = media1250w ? "auto" : userSelectDic.get("Partner") === 'nao' ? "680px" : "635px"

    return (
        <Dialog
            sx={{ "& .MuiDialog-container": { "& .MuiPaper-root": { minWidth: '247px', width: "100%", maxWidth: maxWidthw, height: maxWidthh } } }}
            open={openModal} onClose={handleCloseMessageBoard}
        >
            <DialogContent>
                {firstPage ?
                    <FirstPage
                        setOpenModal={setOpenModal}
                        setFirstPage={setFirstPage}
                        userSelectDic={userSelectDic}
                        curtMins={curtMins}
                        setUserSelectDic={setUserSelectDic}
                        handleRadioChange={handleRadioChange}
                    />
                    :
                    <SecondPage
                        phoneNumberValid={phoneNumberValid}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        setFirstPage={setFirstPage}
                        setCurrentWeek={setCurrentWeek}
                        backendCall={backendCall}
                        inputsModal={inputsModal}
                        submitReservation={submitReservation}
                        setOpenModal={setOpenModal}
                        handleRadioChange={handleRadioChange}
                        userSelectDic={userSelectDic}
                        mbway={mbway}
                        setMbway={setMbway}
                        crediCard={crediCard}
                        setCrediCard={setCrediCard}
                    />}
            </DialogContent>
        </Dialog >
    )
}